import React, { useState, useEffect } from "react";

const GroupByResponseTable = ({ Data }) => {
    const [searchGroup, setSearchGroup] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [key, setKey] = useState("");

    useEffect(() => {
        // Determine the common key dynamically
        if (Data.length > 0) {
            const detectedKey = ["count", "sum", "average"].find(k => k in Data[0]);
            setKey(detectedKey || "N/A");
        }
    }, [Data]);

    const filteredData = Data.filter((item) =>
        item.group.toLowerCase().includes(searchGroup.toLowerCase()) &&
        (searchValue === "" || (key && item[key]?.toString().includes(searchValue)))
    );

    return (
        <div className="p-4">
            <table className="min-w-full border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="p-2 border">Group</th>
                        <th className="p-2 border capitalize">{key}</th>
                    </tr>
                    <tr>
                        <th className="p-2 border">
                            <input
                                type="text"
                                placeholder="Search Group"
                                value={searchGroup}
                                onChange={(e) => setSearchGroup(e.target.value)}
                                className="w-full px-2 py-1 border rounded-lg outline-none"
                            />
                        </th>
                        <th className="p-2 border">
                            <input
                                type="text"
                                placeholder={`Search ${key}`}
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                className="w-full px-2 py-1 border rounded-lg outline-none"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map((item, index) => (
                        <tr key={index} className="border-b text-center">
                            <td className="p-2 border">{item.group}</td>
                            <td className="p-2 border">{key ? item[key] : "N/A"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default GroupByResponseTable;